import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';

import { useLogError } from '#client/hooks/useLogError';
import { GET_BANK_CUSTOMER_INFO } from '#client/queries';

const useBeneficialOwerAdress = () => {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, error, errors, loading } = useQuery(GET_BANK_CUSTOMER_INFO, {
    variables: {
      input: {
        businessEntityUuid
      }
    },
    useCache: false,
    noThrow: true
  });

  useLogError(errors, error);

  const { address, contact } = data?.bankCustomer || {};
  const { street, city, country, state, postalCode } = address || {};
  const { firstName, lastName } = contact || {};

  const fullName = `${firstName} ${lastName}`;

  return {
    loading,
    error,
    street,
    city,
    country,
    state,
    postalCode,
    fullName
  };
};

export default useBeneficialOwerAdress;
